export default {
	'dashboard.SalesCard.today': '今日',
	'dashboard.SalesCard.thisWeek': '本周',
	'dashboard.SalesCard.thisMonth': '本月',
	'dashboard.SalesCard.thisYear': '本年',
	'dashboard.SalesCard.sales': '销售额',
	'dashboard.SalesCard.salesVolume': '销售量',
	'dashboard.SalesCard.salesRank': '门店销售额排名',
	'dashboard.SalesCard.views': '访问量',
	'dashboard.SalesCard.viewsVolume': '访问量',
	'dashboard.SalesCard.viewsRank': '门店访问量排名',
	'dashboard.SalesCard.storeNumber': '门店{number}',
}
